import React from 'react';
import { connect } from 'react-redux';
import cloneDeep from 'lodash/cloneDeep';

// constants
import NotificationConstants from 'app/shared/constants/NotificationConstants';

import AmenitiesTags from 'app/shared/components/postingPath/AmenitiesTags';
import PostingActions from 'app/shared/actions/PostingActions';

// Constellation Components
import { Text } from '@zillow/constellation';

// Styled Components
import {
    StyledAnchor,
} from '../UtilsStyledComponents';

class UnitAmenities extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            amenityInSelectUnits: false,
        };

        this.addAmenity = this.addAmenity.bind(this);
        this.removeUnitAmenity = this.removeUnitAmenity.bind(this);
        this.updateSelectUnits = this.updateSelectUnits.bind(this);
    }

    addAmenity(amenity) {
        this.props.updateStatusMessage('Saving...');
        const updateAmenities = [].concat(this.props.formData.apartmentAmenities);

        // Instantaneously update the form with the amenity while we wait for confirmation from the API.
        updateAmenities.push({
            id: '',
            amenity,
            availableInSelectUnits: this.state.amenityInSelectUnits,
        });
        const lastAddedAmenity = updateAmenities.length - 1;

        this.props.updateFormData({ apartmentAmenities: updateAmenities });
        this.props.dispatch(PostingActions.apartment.amenity.create({
            propertyId: this.props.propertyId,
            amenityText: amenity,
            availableInSelectUnits: this.state.amenityInSelectUnits,
        }))
            .then((result) => {
                this.props.updateStatusMessage('All data saved!', NotificationConstants.SUCCESS);
                this.setState({ amenityInSelectUnits: false });

                // Update recently added amenity with id from API.
                updateAmenities[lastAddedAmenity].id = result.response.amenityId;
                this.props.updateFormData({ apartmentAmenities: updateAmenities });
            })
            .catch((err) => {
                global.TEMPORARY_global_logger.error(err, 'An error occurred.');
                this.props.updateStatusMessage(
                    'Please fix the inputs highlighted in red.',
                    NotificationConstants.ERROR
                );
            });
    }

    removeUnitAmenity(amenityIndex, amenityId) {
        const {
            dispatch,
            formData: { apartmentAmenities },
            updateFormData,
            updateStatusMessage,
        } = this.props;

        const updateObject = {};
        const apartmentAmenitiesCopy = cloneDeep(apartmentAmenities);
        apartmentAmenitiesCopy.splice(amenityIndex, 1);

        updateStatusMessage('Saving...');
        dispatch(PostingActions.apartment.amenity.delete(amenityId))
            .then((response) => {
                if (response.success) {
                    updateStatusMessage('All data saved!', NotificationConstants.SUCCESS);
                    updateObject.apartmentAmenities = apartmentAmenitiesCopy;
                    updateFormData(updateObject);
                } else {
                    updateStatusMessage(
                        'There was an error deleting your amenity. Please try again.',
                        NotificationConstants.ERROR
                    );
                }
            });
    }

    updateSelectUnits() {
        const { amenityInSelectUnits } = this.state;

        this.setState({ amenityInSelectUnits: !amenityInSelectUnits });
    }

    render() {
        const { isInputFormDisabled, formData } = this.props;

        return (
            <div className="UnitAmenities">
                <Text
                    marginBottom="xs"
                    mediaQuery={{
                        lg: {
                            marginBottom: 'sm',
                        },
                    }}
                    fontType="h4"
                    as="div"
                >
                    Unit features
                </Text>

                <StyledAnchor id="unit-amenities" />
                <AmenitiesTags
                    addTag={this.addAmenity}
                    removeTag={this.removeUnitAmenity}
                    tagsArray={formData.apartmentAmenities}
                    placeholder="List amenities found in units"
                    selectUnits={this.state.amenityInSelectUnits}
                    showSelectUnits={true}
                    updateSelectUnits={this.updateSelectUnits}
                    disabled={isInputFormDisabled}
                />
            </div>
        );
    }
}

export default connect()(UnitAmenities);
